export default __webpack_public_path__ + "static/media/provident.f6db31d5.svg";